import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import partnerOrchestratorService from 'services/partnerOrchestratorService';
import { setDlmStatusAndVersion } from 'reducers/dlmReducer';
import { PartnerStatusDto } from 'views/RevisionHistory/Partner/PartnerRevisionDtos';
import { JBErrorDto } from '@bjb-gcrm/gcrm-frontend-components';
import { isNotNullOrUndefined } from 'utils/utils';

export const useFetchPartnerVersions = (techId: string, refetchOnMount: boolean | 'always' = false) => {
  const dispatch = useDispatch();

  const query = useQuery<PartnerStatusDto[], AxiosError<JBErrorDto>>({
    queryKey: ['fetchPartnerVersions', techId],
    queryFn: () => partnerOrchestratorService.getPartnerVersion(techId),
    gcTime: 0,
    refetchOnMount,
  });

  const { error, isError } = query;

  useEffect(() => {
    if (isError && isNotNullOrUndefined(error)) {
      dispatch(setDlmStatusAndVersion({ status: 'ACTIVE', version: 1 }));
    }
  }, [isError, error, dispatch]);

  return query;
};
